<template>
  <div v-loading="isLoading">
    <el-row class="panel-main">
      <el-col class="panel-left">
        <div :class="{'panel-title': true, 'panel-title-student': isStudent}">
          <el-button type="text" icon="el-icon-arrow-left" @click="onBack">{{ isAutonomous ? "返回账单列表": "返回"}}</el-button>
        </div>
        <div class="panel-content cs-fullHeight">
          <el-row v-if="!isStudent">
            <el-col :span="20">
              <h4>{{dataModel.phone}}</h4>
            </el-col>
          </el-row>
          <el-row v-if="!isStudent && wfModel && wfModel.IntroducerName">
            <el-col :span="20">
              <span>推荐人:</span>
              <span>{{wfModel.IntroducerName}}</span>
            </el-col>
          </el-row>
          <el-row v-if="!isStudent">
            <el-col :span="20">
              <span v-if="!dataModel.isAuId" class="cs-color-green">速成新生</span>
              <el-button class="edit-button" size="medium" type="text" @click="onShowMemberInfo">{{showMemberInfoBtnText}}
              </el-button>
            </el-col>
          </el-row>
          <el-row v-if="!isStudent" v-show="isMemberInfoVisible">
            <el-col :span="20">
              <member-info :options="optionsForComponents.memberInfo" :data-in="dataForComponents.memberInfo"></member-info>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">&nbsp;</el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <aef-workflow-card :data="dataForComponents.aefWorkflowCard"></aef-workflow-card>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col class="panel-right">
        <div class="panel-title backgroud-gray-popup">
          <h4 v-if="isAutonomous">费用信息</h4>
          <h4 v-else>收费信息</h4>
          <!-- <span v-if="isAutonomous">使用微信,支付宝或者信用卡付款，需额外收取3%手续费</span> -->
        </div>
        <div class="panel-content cs-fullHeight">
          <el-row>
            <el-col :span="20">
              <el-row>
                <el-col :span="12">
                  <span>占位课数: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{dataModel.aeCount}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span>占位价格: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{dataModel.totalPrice | toCurrency}}</span>
                </el-col>
              </el-row>

              <div v-if="!!dataModel.buyMemberCardPrice">
                <el-row>
                  <el-col :span="12">
                    <span>购买会员: </span>
                  </el-col>
                  <el-col :span="12" class="align-right">
                    <span>{{dataModel.buyMemberCardPrice | toCurrency}}</span>
                  </el-col>
                </el-row>
                <el-row v-if="status === 3 || status === 2">
                  <el-col :span="12">&nbsp;</el-col>
                  <el-col :span="12" class="align-right">
                    <a :href="memberCardConfig.ContractFileV1" target="_blank">黑卡会员须知</a>
                  </el-col>
                </el-row>
              </div>

              <el-row v-if="isAutonomous && paidServiceCharge > 0">
                <el-col :span="12">
                  <span>手续费: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{paidServiceCharge | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="isAutonomous">
                <el-col :span="12">
                  <span>总计: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{totalAmount | toCurrency}}</span>
                </el-col>
              </el-row>
              <!-- <el-row v-if="!!dataModel.balanceCost" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * dataModel.balanceCost) | toCurrency}}</span>
                </el-col>
              </el-row> -->
              <el-row v-if="!!newBalanceCostTotal" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用新余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * newBalanceCostTotal) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!giftBalanceCostTotal" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用赠送余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * giftBalanceCostTotal) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!oldBalanceCostTotal" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用旧余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * oldBalanceCostTotal) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!dataModel.bonusPointAmount" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用积分: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * dataModel.bonusPointAmount) | toCurrency}}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <hr>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <account-info :options="optionsForComponents.accountInfo" :data="dataForComponents.accountInfo"></account-info>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col>
              <hr>
            </el-col>
          </el-row> -->
          <el-row class="section-title">
            <el-col :span="12">
              <span>支付详情: </span>
            </el-col>
            <el-col :span="12" class="cs-ef-status">
              <el-button v-if="isCheckPaymentVisible" :loading="isPaymentChecking" size="small" type="primary" @click="onCheckPaymentClick">检查修复</el-button>
              <el-dropdown v-if="isStatusListVisible" @command="handleStatusChange">
                <span :class="getStatusClass(status)">
                  {{getStatusText(status)}}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in statusList" :key="item.key" :command="item.key" :class="getStatusClass(item.key)">{{item.value}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
          <el-row v-if="isCheckPaymentVisible && !!qrCodeImage">
            <div>支付方式：<i class="icon"><img :src="paymentTypeIcon" /></i></div>
            <img :src="qrCodeImage" />
          </el-row>
          <el-row v-if="isStudent && isAutonomous && status == 1">
            <el-col>
              <el-button size="medium" type="primary" @click="onPaymentClick">支付账单
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <payment-list-view ref="payment-list-view" :data-list="dataModel.accountPayments" :options="optionsForComponents.paymentListView"
                @item-click="onPaymentListViewItemClick" @item-remove="onPaymentListViewItemRemove"></payment-list-view>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-row v-if="!!dataForComponents.accountInfo.excessAmount">
                <el-col :span="14">
                  <span>超出金额: </span>
                </el-col>
                <el-col :span="10" class="align-right">
                  <span>{{dataForComponents.accountInfo.excessAmount | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="14">
                  <span>待付款(除手续费): </span>
                </el-col>
                <el-col :span="10" class="align-right">
                  <span>{{dataForComponents.accountInfo.debt | toCurrency}}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-if="!isAutonomous">
            <el-col>
              <hr>
            </el-col>
          </el-row>
          <!-- <el-row v-if="!isAutonomous">
            <el-col>
              <span>付款备注: </span>
            </el-col>
          </el-row>
          <el-row v-if="!isAutonomous">
            <el-col :span="20">
              <el-input type="textarea" :rows="4" resize="none" v-model="paymentComments" :disabled="true"></el-input>
            </el-col>
          </el-row> -->
          <el-row v-if="!isAutonomous">
            <el-col>
              <span>账目备注: </span>
              <el-button v-if="optionsForComponents.paymentListView.enableEdit" class="edit-button" size="medium margin-left-10" type="text"
                @click="onEidtAccountCommentClick()">编辑备注</el-button>
            </el-col>
          </el-row>
          <el-row v-if="!isAutonomous">
            <el-col :span="20">
              <el-input type="textarea" :rows="4" resize="none" v-model="accountModel.Comment" :disabled="true"></el-input>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="合同签署" :center="true" :close-on-click-modal="false" :visible.sync="contractDialogVisible" width="900px" top="8vh">
      <div class="contract-viewer-container">
        <contractViewer :workflowId="wfModel ? wfModel.Id : 0" v-on:contractSigned="onContractSigned"></contractViewer>
      </div>
    </el-dialog>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentEditorVisible" top="3vh">
      <payment-editor :account-id="accountId" :data="dataForComponents.paymentEditor" :options="optionsForComponents.paymentEditor"
        :conditions="conditionsForComponents.paymentEditor" @closeDialog="onPaymentEditorClose" @callback="onPaymentEditorCallback"></payment-editor>
    </el-dialog>
    <paymentBillEditor key="paymentBillEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :data="dataForComponents.paymentBillEditor"
      @completed="onPaymentBillEditorCompleted" />
    <qrCodeViewer key="qrCodeViewer" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :data="dataForComponents.qrCodeViewer"
      @success="onQRCodeViewerSuccess" />
    <stripeHandler key="stripeHandler" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :data="dataForComponents.stripeHandler" />

    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentCommentEditorVisible" top="5vh">
      <paymentCommentEditor :dataIn="dataForComponents.paymentCommentEditor" @success="onPaymentCommentEditorSuccess" />
    </el-dialog>

    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="accountCommentEditorVisible" top="5vh">
      <accountCommentEditor :dataIn="dataForComponents.accountCommentEditor" @success="onAccountCommentEditorSuccess" />
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.panel-main {
  display: flex;
}

.panel-left {
  flex: 2;
}

.panel-right {
  flex: 1;
  border-left: 1px solid rgb(227, 227, 227);
}

.panel-title {
  padding: 20px 40px 20px 40px;
  min-height: 81px;
}

.icon {
  padding: 0;
  width: 32px;
  height: 32px;

  img {
    vertical-align: middle;
    text-align: center;
    width: 32px;
    height: 32px;
  }
}
</style>

<script>
import { getPaymentImgList } from "@/config/mUtils.js";

import navigator from "../../components/navigator";
import memberInfo from "../common/memberInfo_new";
import aefWorkflowCard from "../../components/addCollectFees/advanceEnrollmentFee/aefWorkflowCard";
import accountInfo from "../../components/finance/accountInfo";
import paymentListView from "../../components/common/paymentListView";
import paymentEditor from "../../components/common/paymentEditor";
import {
  getWorkflowStatusClass,
  getPaymentTypeDescription,
  getAutonomousWorkflowStatusList,
  toDecimal,
} from "../../config/mUtils";
import { getMemberCardConfig } from "@/service/common.service";
import { getStudentMemberInfo } from "../../service/student.service";
import {
  getFormulaListByType,
  saveAccount,
  getAccount,
  createCreditCardPayment,
} from "../../service/finance.service";
import { getContractList } from "@/service/contract.service";
import {
  createWorkflowModel,
  getDiscountArrayFromWorkflow,
  getWorkflowDataByAccountId,
  saveWorkflowStatus,
  refreshEFWorkflowStatus,
} from "../../service/enrollmentFee.service";
import contractViewer from "../../components/contract/contractViewer.vue";
let moment = require("moment");

export default {
  name: "aefAccountProfile",
  props: {
    data: {
      isAutonomous: Boolean,
      accountId: Number,
      account: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      isMemberInfoVisible: false,
      showMemberInfoBtnText: "查看完整信息",
      accountId: 0,
      dataChanged: false,
      memberCardConfig: {
        ContractFile: null,
      },
      formulaList: [],
      contractList: [],
      wfModel: null,
      studentModel: null,
      accountModel: {},
      dataModel: {
        phone: null,
        studentId: 0,
        isAuId: false,
        aeCount: 0,
        totalPrice: 0,
        buyMemberCardPrice: 0,
        bonusPointAmount: 0,
        balanceCost: 0,
        giftBalanceCost: 0,
        oldBalanceCost: 0,
        newBalanceCost: 0,
        giftBalanceCostTax: 0,
        oldBalanceCostTax: 0,
        newBalanceCostTax: 0,
        accountPayments: [],
      },
      optionsForComponents: {
        memberInfo: {
          showTitle: false,
          showPhone: false,
          enableEdit: false,
          enableBuymember: false,
          showIsNew: false,
          enableRegister: false,
        },
        accountInfo: {
          displayType: "simple2",
          isAutonomousModel: false,
        },
        paymentListView: {
          displayType: "simple",
          enableEdit: true,
          enableRemove: false,
          isAutonomous: false,
          isAutonomousPaymentWorkflow: false,
        },
        paymentEditor: {
          showTitle: true,
          allowPaidCount: 0,
        },
      },
      dataForComponents: {
        memberInfo: {
          memberModel: null,
        },
        aefWorkflowCard: {
          discounts: [],
          aeCount: 0,
          totalPrice: 0,
          discountPrice: 0,
          buyMemberCardPrice: 0,
          contractName: null,
        },
        accountInfo: {
          amount: 0,
          amountTax: 0,
          paidAmount: 0,
          paidAmountTax: 0,
          excessAmount: 0,
          debt: 0,
          balanceInStore: 0,
        },
        paymentEditor: {
          index: -1,
          item: null,
        },
        paymentBillEditor: {
          currency: 2,
          paymentAmount: 0,
        },
        qrCodeViewer: {
          workflowId: 0,
          paymentAmount: 0,
          tipAmount: 0,
          paymentType: null,
          description: null,
        },
        stripeHandler: {
          workflowId: 0,
          autonomousPaymentRecordId: null,
          paymentAmount: 0,
          tipAmount: 0,
          description: null,
        },
        paymentCommentEditor: {
          accountPaymentId: 0,
          comment: "",
        },
        accountCommentEditor: {
          accountId: 0,
          comment: "",
        },
      },
      conditionsForComponents: {
        paymentEditor: {
          paidCount: 0,
          paymentAmount: 0,
        },
      },
      paymentEditorVisible: false,
      editIndex: -1,
      editPayment: null,

      isAutonomous: false,
      isStudent: false,
      isCompleted: false,
      status: 0,
      allStatusList: [],
      statusList: [],
      isStatusListVisible: false,
      isCheckPaymentVisible: false,
      isPaymentChecking: false,
      qrCodeImage: null,
      contractDialogVisible: false,
      paymentCommentEditorVisible: false,
      accountCommentEditorVisible: false,
    };
  },
  components: {
    navigator,
    memberInfo,
    aefWorkflowCard,
    accountInfo,
    paymentListView,
    paymentEditor,
    contractViewer,
    paymentBillEditor: () => import("@/components/payApi/paymentBillEditor"),
    qrCodeViewer: () => import("@/components/payApi/qrCodeViewer"),
    stripeHandler: () => import("@/components/stripe/stripeHandler"),
    paymentCommentEditor: () =>
      import("@/components/finance/paymentCommentEditor"),
    accountCommentEditor: () =>
      import("@/components/finance/accountCommentEditor"),
  },
  computed: {
    paidAmount: function () {
      let result = this.__getPaidAmount();

      return result;
    },
    excessAmount: function () {
      if (!this.accountModel || this.paidAmount <= this.accountModel.Amount)
        return 0;

      return this.paidAmount - this.accountModel.Amount;
    },
    paymentComments: function () {
      let comments = "";
      if (!!this.wfModel && !!this.wfModel.Comment) {
        comments = this.wfModel.Comment;
      }
      if (
        !this.accountModel ||
        !this.accountModel.AccountPayments ||
        this.accountModel.AccountPayments.length == 0
      )
        return comments;

      let result = "";
      for (let i = 0; i < this.accountModel.AccountPayments.length; i++) {
        let payment = this.accountModel.AccountPayments[i];
        if (!payment.Enable || !payment.Comment) continue;
        result += `${payment.Comment}\r\n`;
      }

      if (!!comments) comments += "\r\n";
      if (!!result) {
        comments += result;
      }

      return comments;
    },
    paidServiceCharge: function () {
      let result = this.__getPaidServiceCharge();

      return result;
    },
    totalAmount: function () {
      if (this.dataModel) {
        let value = this.dataModel.totalPrice;
        if (this.dataModel.buyMemberCardPrice) {
          value += this.dataModel.buyMemberCardPrice;
        }
        if (this.isAutonomous) {
          value += this.paidServiceCharge;
        }
        return value;
      }
      return 0;
    },
    paymentTypeIcon() {
      if (!this.wfModel) return null;

      let key = this.GLOBAL.enumPaymentType.getAttrValue(
        this.wfModel.PaymentType,
        "key"
      );
      if (!key) return null;

      return this.paymentImgList[key];
    },
    balanceCostTaxTotal() {
      return (
        this.dataModel.newBalanceCostTax +
        this.dataModel.giftBalanceCostTax +
        this.dataModel.oldBalanceCostTax
      );
    },
    giftBalanceCostTotal() {
      if (!!this.dataModel.oldBalanceCost)
        return this.dataModel.giftBalanceCost;

      return this.dataModel.giftBalanceCost + this.balanceCostTaxTotal;
    },
    oldBalanceCostTotal() {
      if (!this.dataModel.oldBalanceCost) return this.dataModel.oldBalanceCost;

      return this.dataModel.oldBalanceCost + this.balanceCostTaxTotal;
    },
    newBalanceCostTotal() {
      if (!!this.dataModel.giftBalanceCost || !!this.dataModel.oldBalanceCost)
        return this.dataModel.newBalanceCost;

      return this.dataModel.newBalanceCost + this.balanceCostTaxTotal;
    },
  },
  beforeCreate() {
    this.paymentImgList = getPaymentImgList();
  },
  created() {
    this.allStatusList = getAutonomousWorkflowStatusList();
    this.isStudent = this.USERMANAGER.isStudent;
    this.init();
  },
  methods: {
    async loadMemberCardConfigFromServer() {
      try {
        let result = await getMemberCardConfig();
        if (!!result && result.success) {
          this.memberCardConfig = result.data;
        }
      } catch (error) {}
    },
    async loadFormulaListFromServer() {
      let result = await getFormulaListByType(
        this.GLOBAL.formulaType.discount,
        this.GLOBAL.accountType.advanceEnrollment
      );
      if (!!result && result.success) {
        this.formulaList = result.data;
      } else {
        this.formulaList = [];
      }
    },
    async loadContractListFromServer() {
      let result = await getContractList(
        this.GLOBAL.contractType.advanceEnrollment
      );
      if (!!result && result.success) this.contractList = result.data;
      else this.contractList = [];
    },
    async loadWorkflowDataFromServer() {
      this.isCheckPaymentVisible = false;
      this.isPaymentChecking = false;
      if (!this.accountId) {
        this.wfModel = null;
        return;
      }

      let result = await getWorkflowDataByAccountId(this.accountId);
      if (!!result && result.success) {
        this.wfModel = result.data;
        this.status = this.wfModel.Status;
        this.isStatusListVisible = false;
        if (this.isAutonomous && !this.USERMANAGER.isStudent) {
          if (this.status != 3) {
            this.isCheckPaymentVisible = true;
            this.qrCodeImage = this.wfModel.QRCodeImage;
          }
          if (
            this.USERMANAGER.isAdmin ||
            this.status == 2 ||
            this.status == 4
          ) {
            this.loadStatusList();
            this.isStatusListVisible = true;
          }
        }
      } else {
        this.wfModel = null;
        this.status = 0;
        this.isStatusListVisible = false;
      }
    },
    loadStatusList() {
      this.statusList = this.allStatusList.filter(
        (i) => i.key != 1 && i.key != this.status
      );
    },
    async loadStudentMemberInfoFromServer(
      studentId = this.dataModel.studentId
    ) {
      if (!studentId) {
        this.studentModel = null;
        return;
      }

      let result = await getStudentMemberInfo(studentId);
      if (!!result && result.success) this.studentModel = result.data;
      else this.studentModel = null;
    },
    loadAccountDataFromProps(account = this.data.account) {
      if (!!account) {
        this.accountId = account.Id;
        this.accountModel = account;
      } else {
        this.accountId = 0;
        this.accountModel = null;
      }
    },
    async saveAccountDataToServer(saveData) {
      if (!saveData) return false;

      let result = await saveAccount(saveData);

      return !!result && result.success;
    },
    async refreshEFWorkflowStatusFromServer() {
      try {
        let workflowId = !!this.wfModel ? this.wfModel.Id : 0;
        let result = await refreshEFWorkflowStatus(workflowId);

        return !!result && result.success;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async init() {
      await this.loadMemberCardConfigFromServer();
      await this.loadFormulaListFromServer();
      await this.loadContractListFromServer();
      await this.reloadAllDataModel();

      this.isLoading = true;
      if (!!this.data) {
        let accountData = null;
        if (this.data.account) {
          accountData = this.data.account;
        } else if (this.data.accountId) {
          let result = await getAccount(this.data.accountId);
          accountData = result.data;
        }
        this.isAutonomous = !!this.data.isAutonomous;

        if (!!accountData) {
          this.loadAccountDataFromProps(accountData);
          await this.loadFormulaListFromServer();
          await this.loadContractListFromServer();
          await this.reloadAllDataModel();
        }
      }

      if (this.isAutonomous) {
        this.isCompleted = this.status != 1;
        this.optionsForComponents.paymentListView = {
          displayType: "simple",
          enableEdit: this.isStudent && this.status == 4,
          enableRemove: false,
          isAutonomous: true,
          isAutonomousPaymentWorkflow: false,
        };
        this.optionsForComponents.accountInfo.isAutonomousModel = true;
      } else {
        if (this.wfModel) {
          this.optionsForComponents.paymentListView.isAutonomousPaymentWorkflow =
            this.wfModel.IsAutonomousPayment;
        }
      }

      this.isLoading = false;
    },
    async reloadAllDataModel(account = this.data.account) {
      this.isMemberInfoVisible = false;
      this.showMemberInfoBtnText = "查看完整信息";

      await this.loadWorkflowDataFromServer();
      let studentId = !!this.wfModel ? this.wfModel.StudentId : 0;
      await this.loadStudentMemberInfoFromServer(studentId);
      this.reloadDataModel();
      this.reloadDataForMemberInfo();
      this.reloadDataForAEFWorkflowCard();
      this.reloadDataForAccountInfo();
    },
    reloadDataModel() {
      if (!!this.wfModel) {
        this.dataModel.phone = this.wfModel.Phone;
        this.dataModel.studentId = this.wfModel.StudentId;
        this.dataModel.aeCount = this.wfModel.AdvanceEnrollmentCount;
        this.dataModel.totalPrice = this.wfModel.AdvanceEnrollmentPrice;
        this.dataModel.buyMemberCardPrice = this.wfModel.BuyMemberCardPrice;
        this.dataModel.balanceCost = this.wfModel.BalanceCost;
        this.dataModel.giftBalanceCost = this.wfModel.GiftBalanceCost;
        this.dataModel.oldBalanceCost = this.wfModel.OldBalanceCost;
        this.dataModel.newBalanceCost = this.wfModel.NewBalanceCost;
        this.dataModel.giftBalanceCostTax = this.wfModel.GiftBalanceCostTax;
        this.dataModel.oldBalanceCostTax = this.wfModel.OldBalanceCostTax;
        this.dataModel.newBalanceCostTax = this.wfModel.NewBalanceCostTax;
        this.dataModel.bonusPointAmount = this.wfModel.BonusPointAmount;
      } else {
        this.dataModel.phone = null;
        this.dataModel.studentId = 0;
        this.dataModel.aeCount = 0;
        this.dataModel.totalPrice = 0;
        this.dataModel.buyMemberCardPrice = 0;
        this.dataModel.balanceCost = 0;
        this.dataModel.giftBalanceCost = 0;
        this.dataModel.oldBalanceCost = 0;
        this.dataModel.newBalanceCost = 0;
        this.dataModel.giftBalanceCostTax = 0;
        this.dataModel.oldBalanceCostTax = 0;
        this.dataModel.newBalanceCostTax = 0;
        this.dataModel.bonusPointAmount = 0;
      }

      if (!!this.studentModel) {
        this.dataModel.isAuId = this.studentModel.IsAuId;
      } else {
        this.dataModel.isAuId = false;
      }

      if (!!this.accountModel) {
        this.dataModel.accountPayments = $.extend(
          true,
          [],
          this.accountModel.AccountPayments
        );
      } else {
        this.dataModel.accountPayments = [];
      }
    },
    reloadDataForMemberInfo() {
      let newData = {
        memberModel: null,
      };

      newData.memberModel = this.studentModel;

      this.dataForComponents.memberInfo = newData;
    },
    reloadDataForAEFWorkflowCard() {
      let newData = {
        discounts: [],
        aeCount: 0,
        totalPrice: 0,
        discountPrice: 0,
        contractName: null,
      };

      if (!!this.wfModel) {
        let discounts = getDiscountArrayFromWorkflow(this.wfModel);
        let contracModel = this.__findContractModel(this.wfModel.ContractId);
        let discountNameArr = [];

        for (let i = 0; i < discounts.length; i++) {
          let formulaId = discounts[i];
          let formulaModel = this.__findFormulaModel(formulaId);
          if (!!formulaModel) discountNameArr.push(formulaModel.LabelName);
        }

        newData.discounts = discountNameArr;
        newData.aeCount = this.wfModel.AdvanceEnrollmentCount;
        newData.totalPrice = this.wfModel.AdvanceEnrollmentPrice;
        newData.discountPrice = this.wfModel.AdvanceEnrollmentPrice;
        newData.buyMemberCardPrice = this.wfModel.BuyMemberCardPrice;
        newData.contractName = !!contracModel ? contracModel.Value : null;
      }

      this.dataForComponents.aefWorkflowCard = newData;
    },
    reloadDataForAccountInfo() {
      let newData = {
        amount: 0,
        paidAmount: 0,
        excessAmount: 0,
        debt: 0,
        balanceInStore: 0,
        isAutonomous: this.isAutonomous,
      };

      if (!!this.accountModel) {
        newData.amount = this.accountModel.Amount;
        newData.amountTax = 0;
        newData.paidAmount = this.paidAmount;
        newData.paidAmountTax = 0;
        newData.paidServiceCharge = this.paidServiceCharge;
        newData.excessAmount = this.excessAmount;
        newData.debt = this.accountModel.Debt;
        if (this.wfModel) {
          newData.balanceInStore = this.wfModel.BalanceInStore;
        }
      }

      this.dataForComponents.accountInfo = newData;
    },
    reloadDataForPaymentEditor() {
      let newData = {
        index: -1,
        item: null,
      };

      newData.index = this.editIndex;
      newData.item = this.editPayment;

      this.dataForComponents.paymentEditor = newData;
    },
    async onBack() {
      let isReload = this.dataChanged;
      this.$emit("close", isReload);
      this.dataChanged = false;
    },
    onShowMemberInfo() {
      this.isMemberInfoVisible = !this.isMemberInfoVisible;
      this.showMemberInfoBtnText = this.isMemberInfoVisible
        ? "隐藏完整信息"
        : "查看完整信息";
    },
    onPaymentListViewItemClick(dataOut) {
      if (dataOut.isEditComment) {
        this.openPaymentCommentEditor(dataOut.item);
      } else if (dataOut.isAutonomous) {
        this.reloadDataForPaymentBillEditor(dataOut.item);
        this.openPaymentBillEditor();
      } else {
        this.editIndex = dataOut.index;
        this.editPayment = dataOut.item;
        this.reloadDataForPaymentEditor();

        this.paymentEditorVisible = true;
      }
    },
    async onPaymentListViewItemRemove(dataOut) {
      let confirmResult = false;
      await this.$confirm("是否删除该项支付?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          confirmResult = true;
        })
        .catch(() => {});
      if (!confirmResult) return;

      let saveData = this.__getSaveModel();
      let payment =
        dataOut.index >= 0 ? saveData.AccountPayments[dataOut.index] : null;
      if (!payment) return;

      payment.Enable = false;

      let result = await this.saveAccountDataToServer(saveData);
      this.$message({
        message: `删除${result ? "成功" : "失败"}`,
        type: result ? "success" : "error",
      });
      if (!result) return;

      this.loadAccountDataFromProps(saveData);
      this.reloadDataModel();
      this.reloadDataForAccountInfo();
      this.dataChanged = true;
    },
    onPaymentEditorClose() {
      this.paymentEditorVisible = false;
      this.editIndex = -1;
      this.editPayment = null;
      this.reloadDataForPaymentEditor();
    },
    async onPaymentEditorCallback(dataOut) {
      let saveData = this.__getSaveModel();
      let payment =
        dataOut.index >= 0 ? saveData.AccountPayments[dataOut.index] : null;
      if (!payment) return;

      payment.PaymentTypeId = dataOut.data.PaymentTypeId;
      payment.ServiceCharge = dataOut.data.ServiceCharge;
      payment.Amount = dataOut.data.Amount;
      payment.Comment = dataOut.data.Comment;

      let result = await this.saveAccountDataToServer(saveData);
      this.$message({
        message: `保存${result ? "成功" : "失败"}`,
        type: result ? "success" : "error",
      });
      if (!result) return;

      this.loadAccountDataFromProps(saveData);
      this.reloadDataModel();
      this.reloadDataForAccountInfo();
      this.dataChanged = true;
    },
    __findFormulaModel(formulaId) {
      if (!this.formulaList || this.formulaList.length == 0) return null;

      let formulaModel = null;

      for (let i = 0; i < this.formulaList.length; i++) {
        let item = this.formulaList[i];
        if (item.Id == formulaId) {
          formulaModel = item;
          break;
        }
      }

      return formulaModel;
    },
    __findContractModel(contractId) {
      if (!this.contractList || this.contractList.length == 0) return null;

      let contracModel = null;

      for (let i = 0; i < this.contractList.length; i++) {
        let item = this.contractList[i];
        if (item.Value == contractId) {
          contracModel = item;
          break;
        }
      }

      return contracModel;
    },
    __getSaveModel() {
      let saveModel = $.extend(true, {}, this.accountModel);

      return saveModel;
    },
    __getPaidAmount(account = this.accountModel) {
      if (
        !account ||
        !account.AccountPayments ||
        account.AccountPayments.length == 0
      )
        return 0;

      let result = 0;
      for (let i = 0; i < account.AccountPayments.length; i++) {
        let payment = account.AccountPayments[i];
        if (!payment.Enable) continue;
        result += payment.Amount;
      }
      return result;
    },
    __getPaidServiceCharge(account = this.accountModel) {
      if (
        !account ||
        !account.AccountPayments ||
        account.AccountPayments.length == 0
      )
        return 0;

      let result = 0;
      for (let i = 0; i < account.AccountPayments.length; i++) {
        let payment = account.AccountPayments[i];
        if (!payment.Enable) continue;
        result += payment.ServiceCharge;
      }
      return result;
    },
    reloadDataForPaymentBillEditor(payment = null) {
      let newData = {
        id: 0,
        currency: 2,
        paymentAmount: 0,
        paymentTypeId: 0,
        paymentDate: new Date(),
        name: null,
        email: null,
        comment: null,
        imageFiles: [],
      };

      if (!!payment) {
        newData.id = payment.Id;
        newData.paymentAmount = toDecimal(payment.Amount + payment.Tax);
        newData.paymentTypeId = payment.PaymentTypeId;
        (newData.paymentDate = Date.parse(payment.DateText)),
          (newData.name = payment.Name);
        newData.email = payment.Email;
        newData.comment = payment.Comment;
        if (Object.typeOf(payment.ImageFiles) === "array") {
          newData.imageFiles = payment.ImageFiles.map((item) => ({
            Id: item.Id,
            FileId: item.FileStorageId,
            FIleName: item.FileStorageName,
            Path: item.FileStoragePath,
          }));
        }
      } else {
        newData.paymentAmount = toDecimal(this.accountModel.Debt);
        newData.paymentTypeId = !!this.wfModel ? this.wfModel.PaymentType : 0;
      }

      this.dataForComponents.paymentBillEditor = newData;
    },
    openPaymentBillEditor() {
      let paymentBillEditor =
        this.$vueRefStore.getChildrenRef("paymentBillEditor");
      if (!paymentBillEditor) return;

      paymentBillEditor.showDialog();
    },
    closePaymentBillEditor() {
      let paymentBillEditor =
        this.$vueRefStore.getChildrenRef("paymentBillEditor");
      if (!paymentBillEditor) return;

      paymentBillEditor.closeDialog();
    },
    onPaymentClick() {
      if (this.wfModel.HasContractAgreed) {
        this.handlePayment();
      } else {
        this.contractDialogVisible = true;
      }
    },
    handlePayment() {
      this.reloadDataForPaymentBillEditor();
      this.openPaymentBillEditor();
    },
    onContractSigned() {
      this.contractDialogVisible = false;
      if (this.wfModel) {
        this.wfModel.HasContractAgreed = true;
        this.handlePayment();
      }
    },
    onPaymentBillEditorCompleted(dataOut) {
      let product = `${this.dataModel.phone} 占位课数${this.dataModel.aeCount}`;
      if (dataOut.paymentTypeId == this.GLOBAL.enumPaymentType.creditCard) {
        this.closePaymentBillEditor();

        this.reloadDataForStripeHandler(
          dataOut.paymentAmount,
          dataOut.serviceCharge,
          product,
          dataOut.comment
        );

        this.$nextTick(() => {
          this.openStripeHandler();
        });
        return;
      }

      if (dataOut.paymentTypeId !== this.GLOBAL.enumPaymentType.emt) {
        this.closePaymentBillEditor();

        this.reloadDataForQRCodeViewer(
          dataOut.paymentAmount,
          dataOut.serviceCharge,
          dataOut.paymentTypeId,
          product,
          dataOut.comment
        );

        this.$nextTick(() => {
          this.openQRCodeViewer();
        });
        return;
      }

      let saveData = this.__getSaveModel();
      let apEntity = saveData.AccountPayments.find(
        (item) => item.Id === dataOut.id
      );
      if (!apEntity) {
        let dateText = moment(new Date()).format("YYYY/MM/DD");
        let payment = {
          Id: dataOut.id,
          Enable: true,
          PaymentTypeDescription: getPaymentTypeDescription(
            dataOut.paymentTypeId
          ),
          PaymentTypeId: dataOut.paymentTypeId,
          Amount: this.accountModel.Amount,
          Tax: this.accountModel.AmountTax,
          ServiceCharge: dataOut.serviceCharge,
          DateText: dateText,
          Name: dataOut.name,
          Email: dataOut.email,
          Comment: dataOut.comment,
          ImageFiles: dataOut.imageFiles.map((item) => ({
            Id: 0,
            AccountPaymentId: 0,
            FileStorageId: item.FileId,
          })),
        };
        saveData.AccountPayments.push(payment);
      } else {
        apEntity.Name = dataOut.name;
        apEntity.Email = dataOut.email;
        apEntity.Comment = dataOut.comment;
        apEntity.ImageFiles = dataOut.imageFiles.map((item) => ({
          Id: item.Id,
          AccountPaymentId: dataOut.id,
          FileStorageId: item.FileId,
        }));
      }

      this.$nextTick(async () => {
        let result = await this.saveAccountDataToServer(saveData);
        this.$message({
          message: `保存${result ? "成功" : "失败"}`,
          type: result ? "success" : "error",
        });
        if (!!result) {
          this.loadAccountDataFromProps(saveData);
          await this.reloadDataModel();
          this.reloadDataForAccountInfo();

          this.closePaymentBillEditor();
          this.isLoading = true;
          saveWorkflowStatus(this.wfModel.Id, 2).then((result) => {
            if (result.success) {
              this.isCompleted = true;
              this.status = 2;
              this.init();
              this.dataChanged = true;
            } else {
              if (result.message) {
                this.$message.error(result.message);
              }
              this.isLoading = false;
            }
          });
        }
      });
    },
    reloadDataForQRCodeViewer(
      paymentAmount,
      tipAmount,
      paymentType,
      product,
      description
    ) {
      let newData = {
        workflowId: 0,
        autonomousPaymentRecordId: null,
        paymentAmount: 0,
        tipAmount: 0,
        paymentType: null,
        product: null,
        description: null,
      };

      newData.workflowId = !!this.wfModel ? this.wfModel.Id : 0;
      newData.autonomousPaymentRecordId = !!this.wfModel
        ? this.wfModel.CurrentAutonomousPaymentRecordId
        : null;
      newData.paymentAmount = paymentAmount;
      newData.tipAmount = tipAmount;
      newData.paymentType = paymentType;
      newData.product = product;
      newData.description = description;

      this.dataForComponents.qrCodeViewer = newData;
    },
    openQRCodeViewer() {
      let qrCodeViewer = this.$vueRefStore.getChildrenRef("qrCodeViewer");
      if (!qrCodeViewer) return;

      qrCodeViewer.showDialog();
    },
    closeQRCodeViewer() {
      let qrCodeViewer = this.$vueRefStore.getChildrenRef("qrCodeViewer");
      if (!qrCodeViewer) return;

      qrCodeViewer.closeDialog();
      this.isCompleted = true;
      this.init();
      this.dataChanged = true;
    },
    onQRCodeViewerSuccess(paymentRequestId) {
      setTimeout(() => {
        this.closeQRCodeViewer();
      }, 5000);
    },
    reloadDataForStripeHandler(paymentAmount, tipAmount, product, description) {
      let newData = {
        workflowId: 0,
        autonomousPaymentRecordId: null,
        paymentAmount: 0,
        tipAmount: 0,
        product: null,
        description: null,
      };

      newData.workflowId = !!this.wfModel ? this.wfModel.Id : 0;
      newData.autonomousPaymentRecordId = !!this.wfModel
        ? this.wfModel.CurrentAutonomousPaymentRecordId
        : null;
      newData.paymentAmount = paymentAmount;
      newData.tipAmount = tipAmount;
      newData.product = product;
      newData.description = description;

      this.dataForComponents.stripeHandler = newData;
    },
    openStripeHandler() {
      let stripeHandler = this.$vueRefStore.getChildrenRef("stripeHandler");
      if (!stripeHandler) return;

      stripeHandler.showDialog();
    },
    getStatusClass(status) {
      return getWorkflowStatusClass(status);
    },
    getStatusText(value) {
      let item = this.allStatusList.find((i) => i.key == value);
      return item.value;
    },
    handleStatusChange(value) {
      let statusText = this.getStatusText(value);
      this.$confirm("您确认要修改支付状态为" + statusText + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isLoading = true;
          saveWorkflowStatus(this.wfModel.Id, value).then((result) => {
            if (result.success) {
              this.status = value;
              this.loadStatusList();
              this.dataChanged = true;
            } else {
              if (result.message) {
                this.$message.error(result.message);
              }
            }
            this.isLoading = false;
          });
        })
        .catch(() => {});
    },
    onCheckPaymentClick() {
      this.$nextTick(async () => {
        this.isPaymentChecking = true;
        await this.refreshEFWorkflowStatusFromServer();
        this.isPaymentChecking = false;
        this.init();
      });
    },
    openPaymentCommentEditor(data) {
      this.dataForComponents.paymentCommentEditor = {
        accountPaymentId: data.Id,
        comment: data.Comment,
      };

      this.paymentCommentEditorVisible = true;
    },
    async onPaymentCommentEditorSuccess(data) {
      this.$message({
        message: `保存备注成功`,
        type: "success",
      });

      let payment = this.accountModel.AccountPayments.find(
        (i) => i.Id === data.accountPaymentId
      );
      payment.Comment = data.comment;
      this.dataModel.accountPayments = $.extend(
        true,
        [],
        this.accountModel.AccountPayments
      );
      this.paymentCommentEditorVisible = false;
      this.dataChanged = true;
    },

    openAccountCommentEditor() {
      this.dataForComponents.accountCommentEditor = {
        accountId: this.accountModel.Id,
        comment: this.accountModel.Comment,
      };

      this.accountCommentEditorVisible = true;
    },
    async onAccountCommentEditorSuccess(data) {
      this.$message({
        message: `保存账目备注成功`,
        type: "success",
      });
      this.accountModel.Comment = data.comment;
      this.accountCommentEditorVisible = false;
      this.dataChanged = true;
    },
    onEidtAccountCommentClick() {
      this.openAccountCommentEditor();
    },
  },
  watch: {
    data: function (newVal) {
      this.init();
      //this.reloadAllDataModel(newVal.account);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/finance/aefAccountProfile.vue